import {
  HTTP_GETBUDGETCOMPSBYBRAND_FETCHING,
  HTTP_GETBUDGETCOMPSBYBRAND_SUCCESS,
  HTTP_GETBUDGETCOMPSBYBRAND_FAILED,
  HTTP_RESET_GETBUDGETCOMPSBYBRAND,
  server,
  OK,
  YES,
} from "src/Constants";
import { httpClient } from "src/utils/HttpClient";

export const setStateBudgetCompSBToFetching = () => ({
  type: HTTP_GETBUDGETCOMPSBYBRAND_FETCHING,
});

export const setStateBudgetCompSBToSuccess = (payload) => ({
  type: HTTP_GETBUDGETCOMPSBYBRAND_SUCCESS,
  payload,
});

export const setStateBudgetCompSBToFailed = (payload) => ({
  type: HTTP_GETBUDGETCOMPSBYBRAND_FAILED,
});

export const clearBudgetCompSB = () => {
  return async (dispatch) => {
    dispatch(setStateBudgetCompSBToSuccess([]));
  };
};

export const getBudgetCompSB = (country, company, year,secid, item) => {
  return async (dispatch) => {
    dispatch(setStateBudgetCompSBToFetching());
    try {
      const result = await httpClient.put(
        `${server.GETBUDGETCOMPBYBRANDS_URL}/${country}/${company}/${year}/${secid}`,
        item,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      dispatch(setStateBudgetCompSBToSuccess(result.data));
      return Promise.resolve(result.data[0]);
    } catch (error) {
      dispatch(setStateBudgetCompSBToFailed());
    }
  };
};
